import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/nextjs/app/embed/components/embed-video.tsx");
